/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('NotificationCampaign_Resource',["$resource","$location",
        function ($resource,$location)
        {
            var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
            return  $resource(baseUrl+'rest/notificationCampaigns/:id',{}, {
                query: { method: 'GET', isArray: true },
                get:   { method: 'GET' },
                getNotifications:   { method: 'GET', isArray: true, url: baseUrl + 'rest/notificationCampaigns/getNotifications/:id'}
            });
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('NotificationCampaign',["NotificationCampaign_Resource","NotificationCampaignData", "MobileDeviceData",
        function (NotificationCampaign_Resource,NotificationCampaignData, MobileDeviceData)
        {
            var  NotificationCampaign = function (resource)
            {
                // Call the parent constructor
                this.id = null;
                this.isDeleted = false;
                this.label = null;
                this.subject = null;
                this.text = null;
                this.type = null;
                this.sendingDate = null;
                this.status = null;
                this.mobiles = [];
                this.filters=[];
                this.version = null;
                if (resource!==undefined && resource!=null)
                    this.loadObject(resource);

                NotificationCampaignData.add(this);
            }
           
            NotificationCampaign.prototype.loadObject = function(object)
            {
                if (!this.id)
                    this.id = object.id;
                this.isDeleted = object.isDeleted;
                this.label = object.label;
                this.subject = object.subject;
                this.text = object.text;
                this.type = object.type;
                if (object.sendingDate)
                    this.sendingDate = new Date(object.sendingDate);
                this.status = object.status;
                this.mobilesId = object.mobilesId;
                if (object.filters) {
                    for (var i = 0; i < object.filters.length; i++) {
                        this.filters.push({
                            code: object.filters[i].code,
                            value: object.filters[i].value,
                            selectedItemViews: object.filters[i].selectedItemViews
                        });
                    }
                }
                if (object.version) {
                    this.version = object.version;
                }
            }
            NotificationCampaign.prototype.loadRef = function()
            {
                if (this.mobilesId)
                {
                    var newMobiles = [];
                    for (var i=0;i<this.mobilesId.length;i++)
                    {
                        var mobile =  MobileDeviceData.getById(this.mobilesId[i]);
                        if (mobile!=null)
                            newMobiles.push(mobile);
                    }
                    this.mobiles = newMobiles;
                }

                delete this.mobilesId;
            }

            NotificationCampaign.prototype.getObjectResource = function() {
                var rsNotificationCampaign = new NotificationCampaign_Resource();
                rsNotificationCampaign.id = this.id;
                rsNotificationCampaign.isDeleted = this.isDeleted;
                rsNotificationCampaign.label = this.label;
                rsNotificationCampaign.subject = this.subject;
                rsNotificationCampaign.text = this.text;
                rsNotificationCampaign.type = this.type;
                if (this.sendingDate) {
                    rsNotificationCampaign.sendingDate = new Date(this.sendingDate);
                }
                rsNotificationCampaign.status = this.status;

                rsNotificationCampaign.mobilesId = [];

                for (var i = 0; i < this.mobiles.length; i++) {
                    rsNotificationCampaign.mobilesId.push(this.mobiles[i].id);
                }
                    rsNotificationCampaign.filters = [];
                if (this.filters) {
                    for (var i = 0; i < this.filters.length; i++) {
                        rsNotificationCampaign.filters.push({
                            code: this.filters[i].code,
                            value: this.filters[i].value,
                            selectedItemViews: this.filters[i].selectedItemViews
                        });
                    }
                }
                return rsNotificationCampaign;
            }

            NotificationCampaign.prototype.copyToObject = function(object){
                object.id = this.id
                object.label = this.label
            }

            NotificationCampaign.prototype.getId = function(){
                return this.id;
            }

            NotificationCampaign.prototype.setId = function(id){
                this.id = id;
            }
            
            return NotificationCampaign;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('NotificationCampaignSrv',["$log","NotificationCampaign_Resource","NotificationCampaign","NotificationCampaignData","UserActionData","ServerSrv",
        function ($log,NotificationCampaign_Resource,NotificationCampaign,NotificationCampaignData,UserActionData,ServerSrv)
        {
            var  notificationCampaignSrv = {};

            notificationCampaignSrv.query = function(successFunction,errorFunction)
            {

                NotificationCampaign_Resource.query(
                    {}, //params
                    function (data) {   //success
                        NotificationCampaignData.clear();

                        for (var i=0;i< data.length;i++) {
                            new NotificationCampaign(data[i]);//auto register to DATA
                        }

                        if (successFunction!== undefined)
                            successFunction(NotificationCampaignData.getActiveList());
                    },
                    function (data) {
                        $log.error(data);
                        if (errorFunction!== undefined)
                            errorFunction(data);
                    });
            }
            notificationCampaignSrv.getNotifications = function(notificationCampaign,successFunction,errorFunction)
            {
                if (notificationCampaign)
                {
                    NotificationCampaign_Resource.getNotifications(
                        {id:notificationCampaign.id}, //params
                        function (data) {
                            if (successFunction!== undefined)
                                successFunction(data);
                        },
                        function (data) {
                            $log.error(data);
                            if (errorFunction!== undefined)
                                errorFunction(data);
                        });
                }
                else
                if (errorFunction!== undefined)
                    errorFunction();
            }

            notificationCampaignSrv.restore =  function(notificationCampaign,successFunction,errorFunction)
            {
                NotificationCampaignData.restore(notificationCampaign);
                ServerSrv.startSavingProcess(notificationCampaignSrv.restoreSync, notificationCampaign, successFunction, errorFunction);
            };
            notificationCampaignSrv.restoreSync =  function(notificationCampaign,successFunction,errorFunction)
            {
                //$timeout (function () {

                var notificationCampaignRes = notificationCampaign.getObjectResource();
                notificationCampaignRes.$save({}, //no params
                    function (data) {
                        try{
                            notificationCampaign.setId(data.id);
                            if (!notificationCampaign.version || (data.version && data.version > notificationCampaign.version))
                                notificationCampaign.version = data.version;
                            UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            }
            notificationCampaignSrv.save =  function(notificationCampaign,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(notificationCampaignSrv.saveSync, notificationCampaign, successFunction, errorFunction);
            };
            notificationCampaignSrv.saveSync =  function(notificationCampaign,successFunction,errorFunction)
            {
                //$timeout (function () {

                var notificationCampaignRes = notificationCampaign.getObjectResource();
                notificationCampaignRes.$save({}, //no params
                    function (data) {
                        try{
                            notificationCampaign.setId(data.id);
                            UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            }
            notificationCampaignSrv.remove =  function(notificationCampaign,successFunction,errorFunction)
            {
                NotificationCampaignData.remove(notificationCampaign);
                ServerSrv.startSavingProcess(notificationCampaignSrv.removeSync, notificationCampaign, successFunction, errorFunction);
            };
            notificationCampaignSrv.removeSync =  function(notificationCampaign,successFunction,errorFunction)
            {
                var notificationCampaignSrv = new NotificationCampaign_Resource();
                notificationCampaignSrv.$remove({id:notificationCampaign.getId()}, //params : id
                    function (data) {
                        try{
                            //TODO UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            }
            notificationCampaignSrv.updateLocally =  function(id,objectToRestore)
            {
                var notificationCampaign =  NotificationCampaignData.getById(id)
                if (notificationCampaign!=null)
                {
                    notificationCampaign.loadObject(objectToRestore);
                    notificationCampaign.loadRef();
                }
                return notificationCampaign;
            }
            notificationCampaignSrv.removeLocally =  function(id,object)
            {
                var notificationCampaign =  NotificationCampaignData.getById(id)
                if (notificationCampaign!=null)
                {
                    NotificationCampaignData.remove(notificationCampaign);
                }
                return notificationCampaign;
            }
            notificationCampaignSrv.addLocally =  function(id,objectToRestore)
            {
                var notificationCampaign =  NotificationCampaignData.getById(id)
                if (notificationCampaign!=null)
                {
                    notificationCampaign.loadObject(objectToRestore);
                    notificationCampaign.loadRef();
                    NotificationCampaignData.add(notificationCampaign);
                }
                return notificationCampaign;
            }
            notificationCampaignSrv.loadRef=  function()
            {
                var notificationCampaigns = NotificationCampaignData.getActiveList();
                for (var i=0;i<notificationCampaigns.length;i++)
                    notificationCampaigns[i].loadRef();
            }

            return notificationCampaignSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('NotificationCampaignData',["$log", function ($log)
    {
        var  notificationCampaignDataSrv =
        {
            indexNotificationCampaigns : [], //Never deleted (used as index)
            activeNotificationCampaigns : [],//active list
            deletedNotificationCampaigns : []//deleted items
        };
        notificationCampaignDataSrv.getById =  function(notificationCampaignId)
        {
            for (var i=0;i<this.indexNotificationCampaigns.length;i++)
                if (this.indexNotificationCampaigns[i].id==notificationCampaignId)
                    return this.indexNotificationCampaigns[i];
            return null;
        }
        notificationCampaignDataSrv.getIndexOf =  function(notificationCampaign)
        {
            if (notificationCampaign)
                return this.indexNotificationCampaigns.indexOf(notificationCampaign);
            return -1;
        }
        notificationCampaignDataSrv.getByIndex =  function(notificationCampaignIndex)
        {
            if (notificationCampaignIndex>=0 && notificationCampaignIndex<this.indexNotificationCampaigns.length)
                return this.indexNotificationCampaigns[notificationCampaignIndex];
            else
                return null;
        }
        notificationCampaignDataSrv.add =  function(notificationCampaign)
        {
            var notificationCampaignArray = this.activeNotificationCampaigns;
            if (notificationCampaign.isDeleted)
                notificationCampaignArray =  this.deletedNotificationCampaigns;
            var index = this.indexNotificationCampaigns.indexOf(notificationCampaign);
            if (index!=-1)
            {
                var realIndex = notificationCampaignArray.indexOf(notificationCampaign);
                if (realIndex==-1)
                    notificationCampaignArray.push(notificationCampaign);
            }
            else
            {
                index = this.indexNotificationCampaigns.length;
                this.indexNotificationCampaigns.push(notificationCampaign);
                notificationCampaignArray.push(notificationCampaign);
            }
            return index;
        }
        notificationCampaignDataSrv.remove =  function(notificationCampaign) //Soft Remove
        {
            var index =  this.activeNotificationCampaigns.indexOf(notificationCampaign);
            if (index!=-1)
            {
                this.activeNotificationCampaigns.splice(index, 1);
                this.deletedNotificationCampaigns.push(notificationCampaign)
                notificationCampaign.isDeleted=true;
            }

        }
        notificationCampaignDataSrv.restore =  function(notificationCampaign) //Soft Remove
        {
            var index =  this.deletedNotificationCampaigns.indexOf(notificationCampaign);
            if (index!=-1)
            {
                this.deletedNotificationCampaigns.splice(index, 1);
                this.activeNotificationCampaigns.push(notificationCampaign)
                notificationCampaign.isDeleted=false;
            }

        }
        notificationCampaignDataSrv.clear =  function()
        {
            this.indexNotificationCampaigns = [];
            this.activeNotificationCampaigns = [];
            this.deletedNotificationCampaigns = [];
        }
        notificationCampaignDataSrv.getActiveList =  function()
        {
            return this.activeNotificationCampaigns;
        }
        notificationCampaignDataSrv.getDeletedList =  function()
        {
            return this.deletedNotificationCampaigns;
        }

        return   notificationCampaignDataSrv;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/NotificationCampaign.js